export type FinderOption = {
  id: string
  label: string
}

export type FinderFacetCriterionBase = {
  facetName: string
  title: string
  tooltip?: string
}

export type FinderUsagesCriterion = FinderFacetCriterionBase & {
  kind: 'usages'
}

export type FinderScreensizeCriterion = FinderFacetCriterionBase & {
  kind: 'screensize'
  rangeMin: number
  rangeMax: number
  values: string[]
}

export type FinderConditionsCriterion = FinderFacetCriterionBase & {
  kind: 'conditions'
}

/** `maxValue` is in the market's major currency unit; the consuming component formats the label. */
export type FinderBudgetPreset = {
  id: string
  maxValue: number
}

export type FinderBudgetCriterion = {
  kind: 'budget'
  facetName: string
  title: string
  presets: FinderBudgetPreset[]
}

export type FinderRequirementsCriterion = {
  kind: 'requirements'
  title: string
  /** Label for the trailing "More filters" action chip. */
  moreFiltersLabel: string
}

export type FinderCriterion =
  | FinderUsagesCriterion
  | FinderBudgetCriterion
  | FinderScreensizeCriterion
  | FinderConditionsCriterion
  | FinderRequirementsCriterion

export type FacetBackedCriterion = Exclude<
  FinderCriterion,
  FinderBudgetCriterion | FinderRequirementsCriterion
>

export function isFacetBackedCriterion(
  criterion: FinderCriterion,
): criterion is FacetBackedCriterion {
  return criterion.kind !== 'budget' && criterion.kind !== 'requirements'
}

export type FinderConfig = {
  id: string
  criteria: FinderCriterion[]
}
